import { Link } from 'react-router-dom';

const movieLinks = [
  { label: '电影', to: '/category?type=movie' },
  { label: '电视剧', to: '/category?type=tv' },
  { label: '热门影片', to: '/category?tag=hot' },
  { label: '一周新片', to: '/category?tag=new' },
];

const newsLinks = [
  { label: '影视资讯', to: '/news' },
  { label: '影视观察', to: '/news' },
  { label: '幕后故事', to: '/news' },
  { label: '片单推荐', to: '/news' },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-100 border-t border-secondary-200">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl" aria-hidden="true" />
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading font-semibold text-lg text-foreground-950">青苹果影院</span>
                <span className="mt-1 text-[10px] tracking-[0.18em] text-foreground-500 uppercase font-label">
                  Green Apple Cinema
                </span>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600">
              青苹果影院是一个专注于影视作品展示与影视资讯阅读的平台。我们整理电影、电视剧的分类索引，记录剧情与幕后故事，帮助影迷更快找到想看的内容，也更从容地读懂一部作品。
            </p>
            <p className="mt-3 text-xs text-foreground-500 leading-relaxed">
              本站为影视信息展示平台，仅提供影片资料与资讯阅读，不提供在线播放、下载与会员服务。站内影片与人物信息均为演示数据。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 font-heading">
              <span className="inline-flex items-center gap-2">
                <i className="ri-compass-3-line text-primary-600" aria-hidden="true" />
                影片浏览
              </span>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {movieLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-700 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 font-heading">
              <span className="inline-flex items-center gap-2">
                <i className="ri-newspaper-line text-accent-600" aria-hidden="true" />
                资讯与探索
              </span>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {newsLinks.map((link, index) => (
                <li key={`${link.label}-${index}`}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-700 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-300/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2025 青苹果影院 Green Apple Cinema. 本站内容仅用于影视信息展示与演示。
          </p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-500">
            <span className="flex items-center gap-1.5">
              <i className="ri-database-2-line" aria-hidden="true" />
              演示数据
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-heart-3-line" aria-hidden="true" />
              为影迷整理
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}